/**
 * Display helpers for dish/meal component weight_in_amount.
 *
 * weight_in_amount is always stored in grams after frontend conversion
 * (TableRowComponentNew.convertToGrams / UNIT_SYSTEM_DOCUMENTATION.md).
 *
 * API unit_abbr on a connection may reflect the product's packaging unit when
 * unit_id is missing or set from product default_unit_id. That must not be used
 * as the unit for weight_in_amount.
 */

export const WEIGHT_IN_AMOUNT_UNIT = "g";

export function getComponentWeightInAmount(component) {
  const raw = component?.weight_in_amount ?? component?.amount;
  if (raw == null || raw === "") return null;
  const num = parseFloat(raw);
  return Number.isFinite(num) ? num : null;
}

export function getComponentWeightInAmountUnit() {
  return WEIGHT_IN_AMOUNT_UNIT;
}

export function formatComponentWeightInAmount(component) {
  const amount = getComponentWeightInAmount(component);
  if (amount == null) return "-";
  return `${amount} ${getComponentWeightInAmountUnit()}`;
}
